var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderPdfClosedFistGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.73 22.5701H79.98V9.83008L92.73 22.5701Z",
    fill: "#CDD9E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.73 22.5701H79.98V9.83008L92.73 22.5701Z",
    stroke: "#CDD9E2",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.93 55.1601C124.24 53.9101 121.24 53.0201 117.81 52.4401C116.431 50.1733 115.231 47.8028 114.22 45.3501C115.783 42.8802 116.859 40.1342 117.39 37.2601C117.64 34.4601 116.51 32.5001 113.77 32.2601C111.03 32.0201 109.56 33.5401 109.26 36.1701C109.08 38.4401 109.79 41.6901 111.06 45.1001C109.584 47.4396 107.954 49.6779 106.18 51.8001C103.128 51.7943 100.103 52.3608 97.2598 53.4701C94.5398 54.6501 93.0998 56.9401 94.4498 59.1001C98.0898 65.1001 105.45 57.0001 107.55 54.6101C110.39 54.5648 113.229 54.7453 116.04 55.1501C117.435 57.4145 119.203 59.4263 121.27 61.1001C123.54 62.6701 125.67 62.7801 127.27 60.5501C128.53 58.6901 128 56.6401 125.93 55.1601ZM97.0498 57.8801C96.1298 55.8801 102.2 54.9701 103.3 54.8801C102.61 55.5701 97.9198 59.7701 97.0498 57.8801ZM113.42 35.0801C115.84 35.3301 113.42 40.6101 112.88 41.6801C112.59 40.6201 110.93 34.7501 113.42 35.0801ZM110 51.7301C110.81 50.5901 111.55 49.5001 112.36 48.3501C112.94 49.5901 113.55 50.7501 114.19 51.9801C112.8 51.8075 111.4 51.724 110 51.7301ZM124.9 58.8601C123.9 60.3201 120.75 56.5601 120.18 55.7901C120.85 56.0001 125.84 57.3401 124.85 58.8601H124.9Z",
    fill: "#B4C5D0",
    stroke: "#B4C5D0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3799 62.0301L100.58 16.5601L146.5 37.9701L125.09 83.8801L109.95 76.8201",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 126.65V46.04H26.64L30.69 53.89H35.93",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 126.65H2.5L13.77 71.7C14.004 70.4061 14.6767 69.2323 15.6748 68.3762C16.6729 67.5202 17.9355 67.0342 19.25 67H101.49C102.187 67.0305 102.868 67.215 103.484 67.5401C104.101 67.8652 104.638 68.3229 105.057 68.8804C105.476 69.4378 105.766 70.0811 105.907 70.764C106.047 71.4469 106.035 72.1525 105.87 72.83L94.87 126.67H87.61",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2699 120.66C77.2699 120.66 77.5299 116.48 80.0099 117.18C82.8999 117.86 80.9199 128.18 80.1499 131.08C79.3799 133.98 76.4399 137.81 76.4399 137.81V141.08H73.3799L71.1299 137.81",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.87 137.81L67.41 141.08H60.71V137.81C60.71 137.81 51.3 129.33 53.51 125.67C55.3 122.82 58.29 126.04 58.29 126.04",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4901 120.41C65.4901 120.41 64.2701 114.8 66.7901 114.58C69.3101 114.36 69.0601 120.15 69.0601 120.15",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0098 126.07V133.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6001 126.07V133.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2002 126.07V133.47",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5498 125C59.5498 125 57.5498 117.39 59.9398 116.58C62.3298 115.77 63.1898 120.41 63.1898 120.41",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3599 120.15C71.3599 120.15 71.4899 114.9 73.6799 115.15C75.8699 115.4 74.9799 120.26 74.9799 120.26",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1499 62.4201V14.4201C37.1499 13.4813 37.5229 12.5808 38.1867 11.917C38.8506 11.2531 39.751 10.8801 40.6899 10.8801H80.3399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 34.22H79.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 42.6001H75.78",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 50.98H79.51",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.77 59.3601H68.03",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderPdfClosedFistGrey);
export default __webpack_public_path__ + "static/media/folder_pdf_closed_fist_grey.9678e25dca654804779eb1d868d2426d.svg";
export { ForwardRef as ReactComponent };